module.exports = __webpack_public_path__ + "static/brandlittledude-e4f0878f5cad6d46ae995b5e7b4142a0.jpeg";